import {leadingZero} from './leading-zero';

type HMObject = {
  h: number;
  m: number;
};

export function minsToHM(minutes: number): HMObject {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return {h, m};
}

export function hmToString(hm: HMObject): string {
  return `${leadingZero(hm.h)}:${leadingZero(hm.m)}`;
}
